import store from 'pages/store';
import SocketClient from 'pages/views/devices/socketClient';
import { CFD_MESSAGES, STATUS } from 'pages/views/devices/socketClient/types';
import { transformPayload } from './sale-transformer';
import { getHubEnabled } from './storage';

export const getCFDEnabled = () => {
  const { selectedDisplay, connection } = store.getState().hub;
  return !!Object.keys(selectedDisplay).length || connection.browserCFD === STATUS.CONNECTED;
};

export function handleCFDSaleUpdate(sale: TSFixMe) {
  if (!getHubEnabled() || !getCFDEnabled()) return;

  let payload: any = transformPayload(sale);
  let event = CFD_MESSAGES.UPDATE_SALE;

  if (sale?.completed === true) {
    event = CFD_MESSAGES.COMPLETE_SALE;
    payload = {
      saleID: payload.saleID,
      paymentType: payload.paymentType,
      change: payload.change,
      calcTotal: payload.calcTotal,
      calcDiscount: payload.calcDiscount,
      completed: true,
    };
  }

  SocketClient.send(event, { sale: payload });
}
